import { render, staticRenderFns } from "./NewRawMaterialAdd.vue?vue&type=template&id=2538386d"
import script from "./NewRawMaterialAdd.vue?vue&type=script&lang=js"
export * from "./NewRawMaterialAdd.vue?vue&type=script&lang=js"
import style0 from "./NewRawMaterialAdd.vue?vue&type=style&index=0&id=2538386d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports